/**
 * GlitchText — text with subtle continuous RGB-split ghosts (red + cyan)
 * and a periodic harsher glitch every ~7s.
 *
 * Renders three stacked copies of the same text: base white, red ghost,
 * cyan ghost. The ghosts are absolutely positioned and animated.
 */
import React from "react";

export default function GlitchText({
  children,
  className = "",
  size = "text-7xl sm:text-8xl",
  tracking = "tracking-[0.18em]",
}) {
  return (
    <div
      className={`relative inline-block leading-none ${className}`}
      data-testid="glitch-text"
    >
      <span
        aria-hidden="true"
        className={`absolute inset-0 font-runic ${size} ${tracking} text-rune-red mix-blend-screen pointer-events-none`}
        style={{
          animation: "glitch-ghost-red 1.6s steps(8) infinite",
          textShadow: "0 0 18px rgba(255, 26, 58, 0.55)",
        }}
      >
        {children}
      </span>
      <span
        aria-hidden="true"
        className={`absolute inset-0 font-runic ${size} ${tracking} text-data-cyan mix-blend-screen pointer-events-none`}
        style={{
          animation: "glitch-ghost-cyan 1.4s steps(7) infinite",
          textShadow: "0 0 18px rgba(0, 224, 255, 0.55)",
        }}
      >
        {children}
      </span>
      <span
        className={`relative font-runic ${size} ${tracking} text-white glitch-title`}
        style={{
          textShadow:
            "0 0 1px rgba(255,255,255,0.7), 0 0 20px rgba(0,224,255,0.25), 0 0 40px rgba(255,26,58,0.18)",
        }}
      >
        {children}
      </span>
    </div>
  );
}
